<template slot="groupTitle">
  <div class="detail-info-form">
    <el-card-title
      class="detail-info-form-title self-title"
      :title="title"
    ></el-card-title>
    <el-form
      :label-width="labelWidth"
      class="el-form ccui-form dic-ccui-form-biserial"
    >
      <el-row :gutter="20">
        <el-col
          v-for="(item, index) in fieldList"
          :key="item.fieldName + index"
          :span="item.span || 24"
        >
          <el-form-item :label="`${item.label}`">
            <template>
              <div class="ellipsis-3" v-if="item.formateFn">
                <span
                  v-if="item.html"
                  v-html="item.formateFn(dataInfo[item.fieldName], dataInfo)"
                ></span>
                <span v-else>{{
                  item.formateFn(dataInfo[item.fieldName], dataInfo)
                }}</span>
              </div>
              <div class="ellipsis-3" v-else-if="item.slot">
                <slot :name="item.slot" :slotData="dataInfo"></slot>
              </div>
              <div class="ellipsis-3" v-else-if="item.slotObj">
                <slot :name="item.slotObj" :slotData="dataInfo[item.fieldName]"></slot>
              </div>
              <div v-else class="ellipsis-3" :title="dataInfo[item.fieldName]">
                {{ dataInfo[item.fieldName] || "-" }}
              </div>
            </template>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "basicInfo",
  props: {
    dataInfo: {
      type: Object,
      default: () => {}
    },
    fieldList: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ""
    },
    labelWidth: {
      type: String,
      default: "163px"
    }
  }
};
</script>

<style scoped lang="scss">
/deep/ .el-form-item .el-form-item__content .ellipsis-3 {
  margin-left: 6px;
}
</style>
